<template>
  <div >

<br />
 <div class="container">
 
<br />
     <h2>{{ $t('FindChannel') }}</h2>
    
     <input v-bind:placeholder="$t('EnterChanneName')" type="text" class="form-control" autocomplete="off" id="firstName" name="name" v-model="query" > <hr />
     <h5>{{ $t('Results') }}</h5>
     <p v-if="results.length==0"> {{ $t('NoResultsInfo') }}</p>
<div class="row">

  <div class="col-12 p-2" v-for="result in results" v-bind:key="result.id" v-bind:onclick="'window.location = \'/'+result.id+'\''" >
      <div style="cursor:pointer" class="seasoncast-card">
     <b v-text="result.name"></b><br />
      <small >@{{result.id}}</small>
     </div>
</div>
</div>
</div>
  </div>

</template>

<script>

import axios from "axios"
import Swal from "sweetalert2"

let API = "https://app.seasoncast.com/"

export default {
  name: 'Home',
  components: {
   
  },
  data: function () {
    return {
      results: [],
      query: this.$route.query.q
    }
  },
  created: async function () {
      if (this.$route.query.q){
  this.search(this.$route.query.q)
  }
  },
   watch: {
    // whenever question changes, this function will run
    query: function () {
this.search(this.query)
    }
   },
  methods: {

    search: async function (query) {
      
    let getEventResponse = await axios.post(API+ "v2/global/search", {
    query: query,
  
  }) 

  let responseData = getEventResponse.data

  if (!responseData.success){
       Swal.fire({
  icon: 'error',
  title: 'Server Error',
  text: 'server error: '+JSON.stringify(responseData.reason),
  footer: 'Try action later or refresh page'
})
  }
console.log(responseData)
  this.results = responseData.results
    


    },
  }
}
</script>
<style lang="scss">
.container {
    max-width: 1100px;
}
</style>
